import { ModelLayer } from '../components/model-context/ModelContext';
import { LAYER_TYPES, LayerSetting } from '../components/project-settings/types';
import { DEFAULT_LAYER_COLOR } from '../constants/colors.ts';
import { LAYER_KEYWORDS, LEGACY_LAYER_KEYWORDS, ROAD_CROSSING_KEYWORDS } from '../constants/layerKeywords';
import { LAYER_NORM_NONE } from '../constants/layers';

/** `pedestrian`: detect Pedestrian zones (IDLC-1129 flag); without it detection is as before. */
export const mapModelLayersToSettings = (
  layers: ModelLayer[],
  { pedestrian = false }: { pedestrian?: boolean } = {},
): LayerSetting[] => {
  return layers.map((layer) => {
    // Find automatic layer type based on keywords
    let detectedType: keyof typeof LAYER_TYPES = 'Unspecified';
    const lowercaseName = layer.originalName.toLowerCase();

    if (pedestrian && ROAD_CROSSING_KEYWORDS.some((keyword) => lowercaseName.includes(keyword))) {
      detectedType = 'Road';
    } else {
      for (const [type, keywords] of Object.entries(pedestrian ? LAYER_KEYWORDS : LEGACY_LAYER_KEYWORDS)) {
        if (keywords.some((keyword) => lowercaseName.includes(keyword))) {
          detectedType = type as keyof typeof LAYER_TYPES;
          break;
        }
      }
    }

    return {
      uuid: layer.uuid,
      threeJsName: layer.threeJsName,
      originalName: layer.originalName,
      displayName: layer.displayName || layer.originalName,
      modelName: layer.modelName,
      type: detectedType,
      illuminated: false,
      canHoldLight: false,
      norm: LAYER_NORM_NONE,
      color: DEFAULT_LAYER_COLOR,
      desiredLuminaireHeight: 8.0,
    };
  });
};
